import Et3Button from "../../../../../../../core/et3-button";
import { DESCRIPTION_SOLVE_GAP } from "../descriptions/descriptions-constants";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";

const PendingResolve = withLiteObserverAndTheme<{
  dataStatusIsPending: boolean;
  acceptDataCallback: () => Promise<void>;
  rejectDataCallback: () => Promise<void>;
}>((props) => {
  const { theme, dataStatusIsPending, acceptDataCallback, rejectDataCallback } =
    props;
  const { colors, unitX } = theme;

  return dataStatusIsPending ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-end"
      alignItems="center"
      withShadow={false}
      width={0}
      height={55}
      color={colors.all.transparent}
      style={{ width: "auto", gap: DESCRIPTION_SOLVE_GAP * unitX }}
      onClick={() => {}}
    >
      <Et3Button
        text={"REJECT"}
        isEnabled={true}
        type={"REJECT"}
        size={"SMALL"}
        onClick={async () => await rejectDataCallback()}
      />
      <Et3Button
        text={"APPROVE"}
        isEnabled={true}
        type={"APPROVE"}
        size={"SMALL"}
        onClick={async () => await acceptDataCallback()}
      />
    </ET3Div>
  ) : null;
});

export default PendingResolve;
